const phoneField = document.querySelector('.js-field-phone__input');

if (phoneField) {
	Promise.all([import('intl-tel-input'), import('intl-tel-input/i18n')])
		.then(([intlTelInput, { ru }]) => {
			intlTelInput.default(phoneField, {
				i18n: ru,
				strictMode: true,
				separateDialCode: true,
				autoPlaceholder: 'off',
				initialCountry: 'ru',
				utilsScript: '/vendor/intl-tel-input/build/js/utils.js', // just for formatting/placeholders etc
			});
		})
		.catch((err) => console.error(err));
}
